import { render, staticRenderFns } from "./index.vue?vue&type=template&id=66fabdeb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=66fabdeb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fabdeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66fabdeb')) {
      api.createRecord('66fabdeb', component.options)
    } else {
      api.reload('66fabdeb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=66fabdeb&scoped=true", function () {
      api.rerender('66fabdeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/Dept/index.vue"
export default component.exports